<template>
  <modal :show.sync="modals.classic">
    <h4 slot="header" class="title title-up">
      {{ $t("app.modules.messages.add.title") }}
    </h4>

    <ValidationObserver ref="formAdd" v-slot="{ handleSubmit }">
      <form
        @submit.prevent="handleSubmit(submitNewMessage)"
        id="formAdd"
        name="formAdd"
      >
        <div class="row">
          <div class="col-sm-12">
            <ValidationProvider
              name="minLength"
              rules="required|min:2"
              v-slot="{ passed, failed }"
            >
              <fg-input
                type="text"
                :error="failed ? $t('app.validation.min_length') + '2' : null"
                :hasSuccess="passed"
                name="minLength"
                :label="$t('app.modules.messages.headers.name')"
                v-model="item.nombreComunicacion"
              >
              </fg-input>
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <ValidationProvider
              name="required"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <fg-input
                :error="failed ? $t('app.validation.required') : null"
                :hasSuccess="passed"
                name="required"
                :label="$t('app.modules.messages.headers.ini_date')"
              >
                <el-date-picker
                  type="date"
                  placeholder="Date Picker"
                  v-model="item.fechaInicio"
                >
                </el-date-picker>
              </fg-input>
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <ValidationProvider
              name="required"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <fg-input
                :error="failed ? $t('app.validation.required') : null"
                :hasSuccess="passed"
                name="required"
                :label="$t('app.modules.messages.headers.end_date')"
              >
                <el-date-picker
                  type="date"
                  placeholder="Date Picker"
                  v-model="item.fechaFin"
                >
                </el-date-picker>
              </fg-input>
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4">
            {{ $t("app.modules.messages.headers.public") }} <br />

            <n-switch v-model="item.tipoUsuarioVisualizar"></n-switch>
          </div>

          <div class="col-sm-4">
            {{ $t("app.general.active") }} <br />

            <n-switch v-model="item.activo"></n-switch>
          </div>

          <div class="col-sm-4">
            <label>{{ $t("app.modules.messages.headers.type") }}</label>
            <el-select
                class="select-danger"
                v-model="typeSelected"
                filterable
                :placeholder="$t('app.modules.orders.headers.type')"
              >
                <el-option :label="$t('app.general.all')" value="0"></el-option>
                <el-option :label="$t('app.modules.messages.types.promo')" value="1"></el-option>
                <el-option :label="$t('app.modules.messages.types.advice')" value="2"></el-option>
                <el-option :label="$t('app.modules.messages.types.bulletin')" value="3"></el-option>
            </el-select>
          </div>
        </div>

        <div clas="row">
          <b>{{ $t("app.translations") }}</b>
          <div
            class="col-sm-12"
            v-for="(lang, index) in item.langs"
            :key="lang.idioma_idIdioma"
          >
            <b>{{ lang.idioma }}</b>
            <ValidationProvider
              name="minLength"
              rules="required|min:2"
              v-slot="{ passed, failed }"
            >
              <fg-input
                type="text"
                :error="failed ? $t('app.validation.min_length') + '2' : null"
                :hasSuccess="passed"
                name="minLength"
                :label="$t('app.modules.messages.add.text')"
                v-model="item.langs[index].textoComunicacion"
              >
              </fg-input>
            </ValidationProvider>
            <ValidationProvider
              name="minLength"
              rules="required|min:2"
              v-slot="{ passed, failed }"
            >
              <fg-input
                type="text"
                :error="failed ? $t('app.validation.min_length') + '2' : null"
                :hasSuccess="passed"
                name="minLength"
                :label="$t('app.modules.messages.add.link')"
                v-model="item.langs[index].enlaceComunicacion"
              >
              </fg-input>
            </ValidationProvider>
            <el-upload
              class="upload-demo"
              ref="upload"
              action="#"
              :on-change="handleFile"
              :name="lang.idioma"
              :auto-upload="false"
            >
              <n-button
                slot="trigger"
                size="small"
                type="primary"
                :id="lang.idioma_idIdioma"
                @click.native="onClick"
                >{{ $t("app.upload.select_file") }}</n-button
              >
              <div class="el-upload__tip" slot="tip">
                {{ $t("app.upload.image_size_limit") }}
              </div>
            </el-upload>
          </div>
        </div>

        <div
          slot="footer"
          style="margin-top: 10px; padding-top: 20px; border-top: outset"
          class="text-right"
        >
          <n-button class="pull-left btn-secondary" @click.native="cancelAdd()">{{
            $t("app.buttons.cancel")
          }}</n-button>
          <n-button native-type="submit" type="primary">{{
            $t("app.buttons.save")
          }}</n-button>
        </div>
      </form>
    </ValidationObserver>
  </modal>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";

export default {
  components: {},
  data() {
    return {
      types: [
        {
          id: 1,
          text: this.$t("app.modules.messages.types.promo")
        },
        {
          id: 2,
          text: this.$t("app.modules.messages.types.advice")
        },
        {
          id: 3,
          text: this.$t("app.modules.messages.types.bulletin")
        }
      ],
      item: {
        idComunicacion: 0,
        nombreComunicacion: "",
        fechaInicio: new Date(),
        fechaFin: new Date(),
        tipoUsuarioVisualizar: false,
        fechaRegistro: new Date(),
        tipoComunicado_idTipoComunicado: 0,
        activo: false
      },
      file: {},
      files: [],
      modals: {
        classic: false,
        notice: false,
        mini: false
      },
      datePickerModal: false,
      imageUrl: "https://picsum.photos/50/50",
      currLang: 0,
      typeSelected: "Todos",
      currText: "",
      currLink: ""
    };
  },
  computed: {
    ...mapState(["availableLangs"])
  },
  created() {},
  mounted() {
    this.item.langs = this.availableLangs.map(lang => ({
      idioma_idIdioma: lang.idIdioma,
      idioma: lang.idioma,
      comunicacion_idComunicacion: 0,
      imagenComunicacion: null,
      textoComunicacion: "",
      enlaceComunicacion: ""
    }));

    EventBus.$on("comunicados-add", async () => {
      this.modals.classic = true;
    });
  },
  methods: {
    cancelAdd() {
      this.$refs.formAdd.reset();
      this.item = {
        idComunicacion: 0,
        nombreComunicacion: "",
        fechaInicio: new Date(),
        fechaFin: new Date(),
        tipoUsuarioVisualizar: false,
        fechaRegistro: new Date(),
        tipoComunicado_idTipoComunicado: 0,
        activo: false
      };
      this.item.langs = this.availableLangs.map(lang => ({
        idioma_idIdioma: lang.idIdioma,
        idioma: lang.idioma,
        comunicacion_idComunicacion: 0,
        imagenComunicacion: null,
        textoComunicacion: "",
        enlaceComunicacion: ""
      }));
      this.modals.classic = false;
    },
    async submitNewMessage() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      await this.addNewMessage();
      this.$swal.close();
    },
    async addNewMessage() {
      const params = {
        Id: 0,
        ClaveIdioma: this.$store.lang,
        Usuario: this.$store.Id,
        Comunicacion: {
          IdComunicacion: 0,
          NombreComunicacion: this.item.nombreComunicacion,
          ImagenEsp: "",
          ImagenIng: "",
          FechaInicio: this.item.fechaInicio,
          FechaFin: this.item.fechaFin,
          TipoUsuarioVisualizar: this.item.tipoUsuarioVisualizar,
          FechaRegistro: this.item.fechaRegistro,
          TipoComunicado_idTipoComunicado: parseInt(this.typeSelected),
          Activo: this.item.activo,
          idUsuario: this.$store.state.user.idUsuario
        }
      };
      await this.$http
        .post(route("Comunicaciones/postComunicacion"), params)
        .then(
          async response => {
            if (response.body.code === 200) {
              this.notifyMessage("success", this.$t("app.promps.save_success"));
              console.log(response.body.id);
              for (let lang of this.item.langs) {
                let formData = new FormData();
                formData.append(
                  "Comunicacion_idComunicacion",
                  response.body.id
                );
                formData.append("ImagenComunicacion", "");
                formData.append("file", lang.imagenComunicacion);
                formData.append("Idioma_idIdioma", lang.idioma_idIdioma);
                formData.append("TextoComunicacion", lang.textoComunicacion);
                formData.append("EnlaceComunicacion", lang.enlaceComunicacion);

                await this.$http
                  .post(
                    route("Comunicaciones/postComunicacionTraduccion"),
                    formData,
                    {
                      headers: {
                        "Content-Type": "multipart/form-data"
                      }
                    }
                  )
                  .then(
                    async responseTraduccion => {
                      if (response.body.code === 200) {
                        // this.notifyMessage("success", this.$t("app.promps.save_success"));
                      } else {
                        this.notifyMessage(
                          "danger",
                          this.$t("app.promps.error")
                        );
                      }
                    },
                    error => {
                      this.notifyMessage("danger", this.$t("app.promps.error"));
                    }
                  )
                  .finally(() => {});
              }
              this.cancelAdd();
              EventBus.$emit("reload-promos");
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    handleFile(file) {
      // console.log(file.raw)
      // console.log("Idioma seleccionado: " + this.currLang)
      const index = this.item.langs.findIndex(
        l => l.idioma_idIdioma == this.currLang
      );
      // console.log(index)
      Vue.set(this.item.langs, index, {
        idioma_idIdioma: this.currLang,
        idioma: "",
        comunicacion_idComunicacion: 0,
        imagenComunicacion: file.raw,
        textoComunicacion: this.item.langs[index].textoComunicacion,
        enlaceComunicacion: this.item.langs[index].enlaceComunicacion
      });
      console.log(this.item.langs);
    },
    onClick: function(e) {
      var clickedElement = e.target;
      console.log(clickedElement.id);
      this.currLang = clickedElement.id;
    }
  }
};
</script>
